import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import PaginationBase from "components/Pagination";

import cls from './Pagination.module.scss';
import Input from "components/Input";

const Pagination = ({ total, current, currentItems, totalItems, pageRangeDisplayed = 5, onChange }) => {
   const { t } = useTranslation();

   const [inputValue, setInputValue] = useState(current || 1);

   
  const handleInputChange = (value) => {
    if (/^\d*$/.test(value)) {
      setInputValue(value);
    }
  }

  useEffect(() => {
    setInputValue(current);
  }, [current]);
   return (
      <div className={cls.pagination}>
         <span className={cls.paginationText}>{t('pagination_pages')}:</span>

         <strong className={cls.paginationCount}>{currentItems} {t('pagination_of')} {totalItems}</strong>

         <PaginationBase
            total={total}
            current={current || 1}
            pageRangeDisplayed={pageRangeDisplayed}
            onChange={current => onChange(current)}
         />

         <div>
            <form
               onSubmit={e => {
                  e.preventDefault();
                  onChange(Number(inputValue));
               }}
            >
               <Input
                  type="text"
                  size="small"
                  className={cls.gotoInput}
                  value={inputValue}
                  onChange={value => handleInputChange(value)}
               />
            </form>
         </div>
      </div>
   )
};

export default Pagination;